import { render, staticRenderFns } from "./ServiceSituationIcon.vue?vue&type=template&id=02efbb3a&"
import script from "./ServiceSituationIcon.vue?vue&type=script&lang=js&"
export * from "./ServiceSituationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports